import { useTranslation } from "react-i18next";

import { useAvailableRegionalManagers } from "~/entity/RegMenReports";
import { FilterFieldOptionsHookResult } from "~/features/filter";
import { onScrollBottomDealers } from "~/hooks/selectDealerValue";
import { REPORT_PERMISSIONS } from "~/pages/RegMen/options";
import { usePermissions } from "~/shared/context/PermissionContext";

/** Типы отчётов, отфильтрованные по праву просмотра (как в старой форме). */
export const useReportOptions = (): FilterFieldOptionsHookResult => {
  const { t } = useTranslation();
  const { hasPermission, loading: loadingPermissions } = usePermissions();

  const options = [
    { value: "reportYear", label: t("regMen.reportYear") },
    { value: "reportDealer", label: t("regMen.reportDealer") },
    { value: "reportRegMen", label: t("regMen.reportRegMen") },
    { value: "reportAll", label: t("regMen.reportAll") },
  ].filter((opt) => {
    if (loadingPermissions) return true;
    const viewPerm = REPORT_PERMISSIONS[opt.value]?.view;
    return hasPermission(viewPerm);
  });

  return { options, loading: loadingPermissions };
};

export const useDealerOptions = (): FilterFieldOptionsHookResult => {
  const {
    dealersForSelect,
    introspectionHandler,
    searchDealer,
    GetViolationTypesLoading,
  } = onScrollBottomDealers();

  return {
    options: dealersForSelect.map(({ value, label }) => ({
      value: String(value),
      label,
    })),
    loading: GetViolationTypesLoading,
    onScrollBottom: introspectionHandler,
    searchOptions: searchDealer,
  };
};

/** Региональные менеджеры для отчёта «по региональному менеджеру» (REST). */
export const useRegMenUserOptions = (): FilterFieldOptionsHookResult => {
  const { regMenOptions, onScrollBottomRegMen, searchRegMen } =
    useAvailableRegionalManagers();

  return {
    options: regMenOptions.map(({ value, label }) => ({
      value: String(value),
      label,
    })),
    onScrollBottom: onScrollBottomRegMen,
    searchOptions: searchRegMen,
  };
};
